import { Component, OnInit, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { CompanyTypeService } from '@http/clients/company-type.service';
import { GenericDropdownComponent } from 'ngx-lib';
import { FormEditorBase, createValueAccessorProvider } from '../../base/form-editor-base';

@Component({
    selector: 'app-report-company-type-form-editor',
    templateUrl: './report-company-type-form-editor.component.html',
    styleUrls: ['./report-company-type-form-editor.component.scss'],
    providers: [createValueAccessorProvider(ReportCompanyTypeFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownComponent]
})
export class ReportCompanyTypeFormEditorComponent extends FormEditorBase<number | null> implements OnInit {
    readonly = input<boolean>(false);
    labelText = input<string>('Company Type');
    placeholderText = input<string>('Select Company Type');

    selectedItem?: any;
    private readonly companyTypeService = inject(CompanyTypeService);

    async ngOnInit(): Promise<void> {
        const types = await this.companyTypeService.getAll();
        this.items.set(types);
        const current = this.selectedValue();
        if (current != null) {
            this.selectedItem = (this.items() ?? []).find((item) => Number(item.id) === Number(current));
        }
    }

    onSelectedItemChange(selected: any): void {
        this.selectedItem = selected;
        if (this.onChange) this.onChange((selected?.id ?? null) as number | null);
        if (this.onTouched) this.onTouched();
        this.valueChange.set(selected?.id ?? null);
    }

    protected override async onEntityTextChange(): Promise<void> {
        return;
    }

    protected override mapSelectedItemsToValue(): number | null {
        return this.selectedItem?.id ?? null;
    }

    protected override mapValueToSelectedItems(): any[] {
        return [];
    }
}
